import { setCookie, getCookie } from '../base/_utilities'
import { adjustLayoutForHeaderHeight } from '../modules/_fullscreen-iframe'

const announcementBar = document.getElementById('announcement_bar')
const announcementBarButton = document.getElementById('announcement_bar_button')
const bottomBox = document.getElementById('bottomBox')
const bottomBoxButton = document.getElementById('bottomBoxButton')

let cookieScriptExists = false;

/**
 * 
 *
 * @see https://support.cookie-script.com/article/20-custom-events
 */
const init = function () {

  if ( typeof CookieScript === 'undefined' ) {
    
    setupAnnouncements()

  } else {
    
    cookieScriptExists = true

    // Before the bottom box is displayed we'll wait until the user
    // has accepted cookies and has accepted the functionality category
    // of cookies - relies on CookieScript integration which is included
    // via Google Tag Manager
    window.addEventListener( 'CookieScriptAccept', function(e) {
      if ( e.detail.categories && e.detail.categories.includes('functionality') ) {
        console.log( e.detail.categories )
        setupAnnouncements()
      }
    })

    window.addEventListener( 'CookieScriptLoaded', function() {
      if ( CookieScript.instance.dispatchEventNames.includes('CookieScriptCategory-functionality') ) {
        setupAnnouncements()
      }
    });

  }

}

/**
 * 
 * 
 * 
 */
const setupAnnouncements = function() {
  setupBottomBox()
  setupAnnouncementBar()
}

/**
 * 
 * 
 * 
 */
const weCanUseCookies = function() {

  if ( !cookieScriptExists ) {
    return true;
  }

  if ( typeof CookieScript.instance.dispatchEventNames !== 'undefined' ) {
    if ( CookieScript.instance.dispatchEventNames.includes('CookieScriptCategory-functionality') ) {
      return true;
    }
  }

  return false;

}

/**
 *
 *
 *
 */
// prettier-ignore
const setupAnnouncementBar = function () {
  if (announcementBarButton && announcementBar) {
    
		const announcementBarCookieID = announcementBar.getAttribute('data-apm-abar-cookie-id')
			? announcementBar.getAttribute('data-apm-abar-cookie-id') : ''
    
		const announcementBarCookieDuration = announcementBar.getAttribute('data-apm-abar-cookie-duration')
      ? announcementBar.getAttribute('data-apm-abar-cookie-duration') : ''

    // If there is no cookie set to dismiss the bar remove the .is-dismissed class from the bar
    // and add body class for some addition top padding for the content
    if (!getCookie(announcementBarCookieID)) {
      announcementBar.classList.remove('is-dismissed')
      document.body.classList.add('has-announcement-bar')
    }

    announcementBarButton.addEventListener('click', () => {

      if ( weCanUseCookies() ) {
        setCookie(announcementBarCookieID, true, announcementBarCookieDuration)
      }

      announcementBar.classList.add('is-fading')

      setTimeout(() => {
        announcementBar.classList.add('is-dismissed')
        document.body.classList.remove('has-announcement-bar')

        if (
          document.body.classList.contains('page-template-fullscreen-iframe')
        ) {
          adjustLayoutForHeaderHeight()
        }
      }, 250)
    })

  }
}

/**
 *
 *
 *
 */
// prettier-ignore
const setupBottomBox = function () {
  if (bottomBox && bottomBoxButton) {

		const bottomBoxCookieDuration = bottomBox.getAttribute('data-apm-bbox-cookie-duration')
    const bottomBoxCookieID = bottomBox.getAttribute('data-apm-bbox-cookie-id') ? bottomBox.getAttribute('data-apm-bbox-cookie-id') : ''

		// check for cookie – if it does not exist show the bottom box
		if ( !getCookie(bottomBoxCookieID) ) {
      bottomBox.classList.add('is-visible')
    }

    bottomBoxButton.addEventListener('click', () => {
      if ( weCanUseCookies() ) {
        setCookie(bottomBoxCookieID, true, bottomBoxCookieDuration)
      }
			bottomBox.classList.remove('is-visible')
    })

  }
}

const api = {
  init: init
}

export default api
